import api from 'service/api'

const dponetAPI = api.create('guestPortal')

const get = async (params) => {
  return await dponetAPI.get('/departments', { params })
}

export default { get }
